export default __webpack_public_path__ + "static/media/speraxlogo.bb15d694.svg";